(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.newsletterSignup = {
    attach: function (context, settings) {
      $('.newsletter-form', context).each(function () {
        // Define required variables
        const newsletterEmail = $('.newsletter-form__email', this);
        const newsletterSignup = $('.newsletter-form__signup', this);
        const signupLink = $(newsletterSignup).attr('href');
        $(newsletterSignup).click(function () {
          // Get email entered when button is clicked
          const emailAddress = $(newsletterEmail).val();
          // Make new link with email address merged on the end
          const newLink = signupLink + emailAddress;
          // Replace previous button link
          $(newsletterSignup).attr('href', newLink);
        });
      });
    }
  };
})(window.Drupal, window.jQuery);
